module.exports = __webpack_public_path__ + "static/water-bottom-89c8ffc8ed270b1e17852a7cfe4896c7.png";